class CalculatorModal {
  constructor() {
    this.modal = null;
    this.currentStep = 'form';
    this.formData = {
      type: 'room',
      windows: 0,
      doors: 0,
      length: 0,
      width: 0,
      height: 0
    };
    this.results = {
      squareFootage: 0,
      paintNeeded: 1,
      primerNeeded: 1
    };
    this.productData = {
      paint: null,
      primer: null,
      kit: null
    };
    this.isAddingToCart = false;

    this.loadProductData();
    this.init();
  }

  init() {
    this.createModal();
    this.attachEventListeners();
  }

  loadProductData() {
    try {
      const paintScript = document.getElementById('calculator-paint');
      const primerScript = document.getElementById('calculator-primer');
      const kitScript = document.getElementById('calculator-kit');

      if (paintScript) {
        this.productData.paint = JSON.parse(paintScript.textContent);
      }

      if (primerScript) {
        this.productData.primer = JSON.parse(primerScript.textContent);
      }

      if (kitScript) {
        this.productData.kit = JSON.parse(kitScript.textContent);
      }
    } catch (error) {
      console.error('Error loading product data:', error);
    }
  }

  createModal() {
    const modalHTML = `
      <div class="calculator-modal" id="calculator-modal">
        <div class="calculator-modal__content">
          <button class="calculator-modal__close" data-action="close-modal"></button>

          <!-- Step 1: Form -->
          <div class="calculator-modal__step calculator-modal__step--form is-active" data-step="form">
            <h2 class="calculator-modal__title">Paint coverage calculator</h2>

            <div class="calculator-modal__divider"></div>

            <div class="calculator-modal__section-title">I'm painting a:</div>

            <div class="calculator-modal__radio-group">
              <label class="calculator-modal__radio-option">
                <input type="radio" name="paintType" value="room" class="calculator-modal__radio-input" checked data-field="type">
                <span class="calculator-modal__radio-visual"></span>
                <span class="calculator-modal__radio-label">Room</span>
              </label>
              <label class="calculator-modal__radio-option">
                <input type="radio" name="paintType" value="wall" class="calculator-modal__radio-input" data-field="type">
                <span class="calculator-modal__radio-visual"></span>
                <span class="calculator-modal__radio-label">Wall</span>
              </label>
            </div>

            <div class="calculator-modal__section-title calculator-modal__windows-doors-title">
              How many windows and doors are in your room?
            </div>

            <div class="calculator-modal__form-row">
              <div class="calculator-modal__field-group">
                <div class="calculator-modal__select-field">
                  <label class="calculator-modal__field-label" for="windows-select">Windows</label>
                  <select class="calculator-modal__select" id="windows-select" data-field="windows">
                    <option value="">select</option>
                    ${Array.from({length: 11}, (_, i) => `
                      <option value="${i}">${i}</option>
                    `).join('')}
                  </select>
                </div>
              </div>
              <div class="calculator-modal__field-group">
                <div class="calculator-modal__select-field">
                  <label class="calculator-modal__field-label" for="doors-select">Doors</label>
                  <select class="calculator-modal__select" id="doors-select" data-field="doors">
                    <option value="">select</option>
                    ${Array.from({length: 10}, (_, i) => `
                      <option value="${i + 1}">${i + 1}</option>
                    `).join('')}
                  </select>
                </div>
              </div>
            </div>

            <div class="calculator-modal__section-title calculator-modal__dimensions-title">
              Enter your room's dimensions
            </div>

            <div class="calculator-modal__form-row calculator-modal__dimensions-row">
              <div class="calculator-modal__field-group">
                <div class="calculator-modal__input-field">
                  <div class="calculator-modal__field-label">Length</div>
                  <div class="calculator-modal__input-wrapper">
                    <input type="number" class="calculator-modal__input" placeholder="0" data-field="length" min="0" step="0.1">
                    <span class="calculator-modal__unit">ft.</span>
                  </div>
                </div>
              </div>
              <div class="calculator-modal__field-group">
                <div class="calculator-modal__input-field">
                  <div class="calculator-modal__field-label">Width</div>
                  <div class="calculator-modal__input-wrapper">
                    <input type="number" class="calculator-modal__input" placeholder="0" data-field="width" min="0" step="0.1">
                    <span class="calculator-modal__unit">ft.</span>
                  </div>
                </div>
              </div>
              <div class="calculator-modal__field-group">
                <div class="calculator-modal__input-field">
                  <div class="calculator-modal__field-label">Height</div>
                  <div class="calculator-modal__input-wrapper">
                    <input type="number" class="calculator-modal__input" placeholder="0" data-field="height" min="0" step="0.1">
                    <span class="calculator-modal__unit">ft.</span>
                  </div>
                </div>
              </div>
            </div>

            <button class="calculator-modal__calculate-btn" data-action="calculate">Calculate</button>
          </div>

          <!-- Step 2: Results -->
          <div class="calculator-modal__step calculator-modal__step--results" data-step="results">
            <div class="calculator-modal__results-header">
              <button class="calculator-modal__back-btn" data-action="back-to-form"></button>
              <h2 class="calculator-modal__results-title">What you'll need</h2>
            </div>
            <button class="calculator-modal__reset-link" data-action="reset">Reset</button>

            <div class="calculator-modal__divider"></div>

            <div class="calculator-modal__results-summary">
              <span class="calculator-modal__results-text"></span>
            </div>

            <div class="calculator-modal__products">
              ${this.generateProductCard('primer')}
              ${this.generateProductCard('paint')}
            </div>

            <button class="calculator-modal__add-to-cart" data-action="add-to-cart">Add To Cart · $175</button>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', modalHTML);
    this.modal = document.getElementById('calculator-modal');
  }

  generateProductCard(productType) {
    const product = this.productData[productType];

    if (!product) {
      return `<div class="calculator-modal__product-card">Product data not available</div>`;
    }

    const defaultVariant = product.variants?.[0];
    const productImage = product.featured_image || defaultVariant?.featured_image;
    const imageUrl = productImage ? productImage.replace(/\.(jpg|jpeg|png|gif|webp)/, '_300x300.$1') : '';

    // Generate variant options for paint (assuming variants represent different finishes)
    const variantOptions = productType === 'paint' && product.variants?.length > 1
      ? this.generateVariantOptions(product.variants)
      : '';

    return `
      <div class="calculator-modal__product-card">
        <div class="calculator-modal__product-image">
          ${imageUrl
            ? `<img src="${imageUrl}" alt="${product.title}" loading="lazy" />`
            : `<div style="width: 100%; height: 100%; background: linear-gradient(135deg, #e8f5e8 0%, #d4f1d4 100%); display: flex; align-items: center; justify-content: center; font-size: 14px; color: #666;">${product.title}</div>`
          }
        </div>
        <div class="calculator-modal__product-details">
          <h3 class="calculator-modal__product-name">${product.title}</h3>
          <div class="calculator-modal__product-options">
            ${variantOptions}
            <div class="calculator-modal__quantity-selector" data-product="${productType}">
              <button class="calculator-modal__quantity-btn calculator-modal__quantity-btn--minus" data-action="decrease-quantity"></button>
              <span class="calculator-modal__quantity-value">1</span>
              <button class="calculator-modal__quantity-btn calculator-modal__quantity-btn--plus" data-action="increase-quantity"></button>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  generateVariantOptions(variants) {
    if (!variants || variants.length <= 1) return '';

    const options = variants.map((variant, index) => {
      const isSelected = index === 0 ? 'is-selected' : '';
      const variantTitle = variant.title !== 'Default Title' ? variant.option2 : `Option ${index + 1}`;

      return `
        <div class="calculator-modal__finish-option ${isSelected}" data-variant-id="${variant.id}" data-finish="${(variant.option2 || variant.title).toLowerCase()}">
          <div class="calculator-modal__finish-swatch ${isSelected}"></div>
          <span class="calculator-modal__finish-text">${variantTitle}</span>
        </div>
      `;
    }).join('');

    return `
      <div>
        <div class="calculator-modal__finish-label">Finish</div>
        <div class="calculator-modal__finish-options">
          ${options}
        </div>
      </div>
    `;
  }

  getProductPrice(productType) {
    const variant = this.getCurrentVariant(productType);
    if (!variant) return 0;

    // Price is usually in cents, convert to dollars
    return variant.price / 100;
  }

  calculateKitQuantities(paintNeeded, primerNeeded) {
    // Calculate how many kits we need based on the minimum of paint and primer needed
    const kitQuantity = Math.min(paintNeeded, primerNeeded);

    // Calculate remaining individual products needed
    const remainingPaint = paintNeeded - kitQuantity;
    const remainingPrimer = primerNeeded - kitQuantity;

    return {
      kitQuantity,
      remainingPaint,
      remainingPrimer
    };
  }

  calculatePricing(paintQuantity, primerQuantity) {
    const paintPrice = this.getProductPrice('paint');
    const primerPrice = this.getProductPrice('primer');
    const kitPrice = this.getProductPrice('kit');

    // Calculate original price (paint + primer individually)
    const originalPrice = (paintQuantity * paintPrice) + (primerQuantity * primerPrice);

    // Calculate kit-based pricing
    const { kitQuantity, remainingPaint, remainingPrimer } = this.calculateKitQuantities(paintQuantity, primerQuantity);
    const actualPrice = (kitQuantity * kitPrice) + (remainingPaint * paintPrice) + (remainingPrimer * primerPrice);

    return {
      originalPrice,
      actualPrice,
      kitQuantity,
      remainingPaint,
      remainingPrimer
    };
  }

  getCurrentVariant(productType) {
    const product = this.productData[productType];
    if (!product || !product.variants) return null;

    // For both paint and kit, find the selected variant based on finish selection
    if (productType === 'paint' || productType === 'kit') {
      const selectedFinish = this.modal?.querySelector('.calculator-modal__finish-option.is-selected');
      if (selectedFinish) {
        // For paint, use the variant ID directly
        if (productType === 'paint') {
          const variantId = selectedFinish.dataset.variantId;
          return product.variants.find(v => v.id.toString() === variantId);
        }

        // For kit, find the variant that matches the selected finish
        if (productType === 'kit') {
          const selectedFinishValue = selectedFinish.dataset.finish;

          // First try to find exact matches in option values
          let matchedVariant = product.variants.find(variant => {
            const option1 = variant.option1?.toLowerCase() || '';
            const option2 = variant.option2?.toLowerCase() || '';
            const option3 = variant.option3?.toLowerCase() || '';

            return option1 === selectedFinishValue ||
                   option2 === selectedFinishValue ||
                   option3 === selectedFinishValue;
          });

          // If no exact match, try partial matches
          if (!matchedVariant) {
            matchedVariant = product.variants.find(variant => {
              const variantTitle = variant.title?.toLowerCase() || '';
              const option1 = variant.option1?.toLowerCase() || '';
              const option2 = variant.option2?.toLowerCase() || '';
              const option3 = variant.option3?.toLowerCase() || '';

              return variantTitle.includes(selectedFinishValue) ||
                     option1.includes(selectedFinishValue) ||
                     option2.includes(selectedFinishValue) ||
                     option3.includes(selectedFinishValue);
            });
          }

          return matchedVariant || product.variants[0]; // Fallback to first variant if no match
        }
      }
    }

    // Default to first variant for primer or if no finish selection
    return product.variants[0];
  }

  updateTotalPrice() {
    if (!this.modal) return;

    const paintQuantity = parseInt(this.modal.querySelector('[data-product="paint"] .calculator-modal__quantity-value')?.textContent) || 0;
    const primerQuantity = parseInt(this.modal.querySelector('[data-product="primer"] .calculator-modal__quantity-value')?.textContent) || 0;

    const pricing = this.calculatePricing(paintQuantity, primerQuantity);

    const addToCartBtn = this.modal.querySelector('.calculator-modal__add-to-cart');
    if (addToCartBtn) {
      // Show actual price with compare at price if there are savings
      if (pricing.actualPrice < pricing.originalPrice) {
        addToCartBtn.innerHTML = `Add To Cart · <span class="calculator-modal__price--strike">$${pricing.originalPrice.toFixed(2)}</span> $${pricing.actualPrice.toFixed(2)}`;
      } else {
        addToCartBtn.textContent = `Add To Cart · $${pricing.actualPrice.toFixed(2)}`;
      }
    }
  }

  attachEventListeners() {
    // Close modal events
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal || e.target.dataset.action === 'close-modal') {
        this.closeModal();
      }
    });

    // Form field changes (radio buttons and select elements)
    this.modal.addEventListener('change', (e) => {
      if (e.target.dataset.field === 'type') {
        this.handleTypeChange(e.target.value);
      } else if (e.target.dataset.field && (e.target.dataset.field === 'windows' || e.target.dataset.field === 'doors')) {
        this.updateFormData(e.target.dataset.field, parseInt(e.target.value) || 0);
      }
    });

    // Input field changes
    this.modal.addEventListener('input', (e) => {
      if (e.target.dataset.field) {
        this.updateFormData(e.target.dataset.field, parseFloat(e.target.value) || 0);
      }
    });

    // Action buttons
    this.modal.addEventListener('click', (e) => {
      // Find the closest element with data-action attribute
      const actionElement = e.target.closest('[data-action]');
      if (!actionElement) return;

      const action = actionElement.dataset.action;
      switch (action) {
        case 'calculate':
          this.calculate();
          break;
        case 'reset':
          this.reset();
          break;
        case 'back-to-form':
          this.backToForm();
          break;
        case 'increase-quantity':
          this.adjustQuantity(actionElement, 1);
          break;
        case 'decrease-quantity':
          this.adjustQuantity(actionElement, -1);
          break;
        case 'add-to-cart':
          this.addToCart();
          break;
      }
    });

    // Finish selection
    this.modal.addEventListener('click', (e) => {
      if (e.target.closest('[data-finish]')) {
        this.selectFinish(e.target.closest('[data-finish]'));
        // Update pricing when variant changes
        this.updateTotalPrice();
      }
    });

    // Escape key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('is-open')) {
        this.closeModal();
      }
    });
  }

  openModal() {
    this.modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  closeModal() {
    this.modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  handleTypeChange(type) {
    this.formData.type = type;

    const windowsDoorsTitle = this.modal.querySelector('.calculator-modal__windows-doors-title');
    const dimensionsTitle = this.modal.querySelector('.calculator-modal__dimensions-title');
    const lengthField = this.modal.querySelector('[data-field="length"]').closest('.calculator-modal__field-group');

    if (type === 'wall') {
      windowsDoorsTitle.textContent = 'How many windows and doors are on this wall?';
      dimensionsTitle.textContent = 'Enter your wall\'s dimensions';
      lengthField.style.display = 'none';
      this.formData.length = 0;
    } else {
      windowsDoorsTitle.textContent = 'How many windows and doors are in your room?';
      dimensionsTitle.textContent = 'Enter your room\'s dimensions';
      lengthField.style.display = 'block';
    }
  }

  updateFormData(field, value) {
    this.formData[field] = value;
  }

  calculate() {
    // Validate required fields
    const { type, width, height, length, windows, doors } = this.formData;

    if (!width || !height || (type === 'room' && !length)) {
      this.showError('Please fill in all dimension fields.');
      return;
    }

    let totalArea;

    if (type === 'wall') {
      // WALL FORMULA: Total Area = Width * Height - 15 * Windows - 25 * Doors
      totalArea = width * height - (15 * windows) - (25 * doors);
    } else {
      // ROOM FORMULA:
      // Ceiling Area = Length * Width
      // Wall Area = 2 * (Length + Width) * Height - 15 * Windows - 25 * Doors
      // Total Area = Ceiling Area + Wall Area
      const ceilingArea = length * width;
      const wallArea = 2 * (length + width) * height - (15 * windows) - (25 * doors);
      totalArea = ceilingArea + wallArea;
    }

    // Ensure total area is not negative
    totalArea = Math.max(0, totalArea) * 0.75;
    this.results.squareFootage = Math.round(totalArea);

    // Calculate gallons needed (round up)
    // Gallons of Primer = Total Area / 400 (rounded up)
    // Gallons of Paint = Total Area / 137.5 (rounded up)
    this.results.primerNeeded = Math.max(1, Math.ceil(totalArea / 400));
    this.results.paintNeeded = Math.max(1, Math.ceil(totalArea / 137.5));

    this.showResults();
  }

  showResults() {
    // Update results text
    const resultsText = this.modal.querySelector('.calculator-modal__results-text');
    const typeText = this.formData.type === 'room' ? 'room' : 'wall';
    const areaText = this.formData.type === 'room' ? 'room' : 'one wall';

    resultsText.innerHTML = `You're painting ${areaText} that's about <strong>${this.results.squareFootage} sq. ft.</strong> of surface area. We recommend <strong>${this.results.paintNeeded} gallon${this.results.paintNeeded > 1 ? 's' : ''}</strong> of Perfect White paint and <strong>${this.results.primerNeeded} gallon${this.results.primerNeeded > 1 ? 's' : ''}</strong> of primer.`;

    // Update quantity selectors
    const paintQuantity = this.modal.querySelector('[data-product="paint"] .calculator-modal__quantity-value');
    const primerQuantity = this.modal.querySelector('[data-product="primer"] .calculator-modal__quantity-value');

    paintQuantity.textContent = this.results.paintNeeded;
    primerQuantity.textContent = this.results.primerNeeded;

    // Update pricing
    this.updateTotalPrice();

    // Switch to results step
    this.switchStep('results');
  }

  switchStep(step) {
    this.currentStep = step;

    const steps = this.modal.querySelectorAll('.calculator-modal__step');
    steps.forEach(stepEl => {
      stepEl.classList.toggle('is-active', stepEl.dataset.step === step);
    });
  }

  reset() {
    // Reset form data
    this.formData = {
      type: 'room',
      windows: 0,
      doors: 0,
      length: 0,
      width: 0,
      height: 0
    };

    // Reset form UI
    const roomRadio = this.modal.querySelector('[value="room"]');
    roomRadio.checked = true;
    this.handleTypeChange('room');

    // Reset select elements
    const selectElements = this.modal.querySelectorAll('.calculator-modal__select');
    selectElements.forEach(select => {
      select.value = '';
    });

    // Reset inputs
    const inputs = this.modal.querySelectorAll('.calculator-modal__input');
    inputs.forEach(input => {
      input.value = '';
    });

    // Reset finish selection
    const finishOptions = this.modal.querySelectorAll('.calculator-modal__finish-option');
    finishOptions.forEach((option, index) => {
      const isFirst = index === 0;
      option.classList.toggle('is-selected', isFirst);
      const swatch = option.querySelector('.calculator-modal__finish-swatch');
      swatch.classList.toggle('is-selected', isFirst);
    });

    // Switch back to form step
    this.switchStep('form');
  }

  backToForm() {
    // Simply switch back to the form step without resetting data
    this.switchStep('form');
  }

  selectFinish(option) {
    const finishOptions = this.modal.querySelectorAll('.calculator-modal__finish-option');
    const swatches = this.modal.querySelectorAll('.calculator-modal__finish-swatch');

    finishOptions.forEach(opt => opt.classList.remove('is-selected'));
    swatches.forEach(swatch => swatch.classList.remove('is-selected'));

    option.classList.add('is-selected');
    option.querySelector('.calculator-modal__finish-swatch').classList.add('is-selected');
  }

  adjustQuantity(button, change) {
    const quantitySelector = button.closest('.calculator-modal__quantity-selector');
    const quantityValue = quantitySelector.querySelector('.calculator-modal__quantity-value');
    const currentValue = parseInt(quantityValue.textContent);
    const newValue = Math.max(0, currentValue + change);

    quantityValue.textContent = newValue;

    // Update total price
    this.updateTotalPrice();
  }

  showError(message = 'An error occurred. Please try again.') {
    // Try to use cart drawer's error notification if available
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.showError) {
      cartDrawer.showError(message);
      return;
    }

    // Fallback: create our own notification
    let errorNotification = document.querySelector('.calculator-modal__error-notification');

    if (!errorNotification) {
      errorNotification = document.createElement('div');
      errorNotification.className = 'calculator-modal__error-notification';
      errorNotification.setAttribute('role', 'alert');
      errorNotification.setAttribute('aria-live', 'polite');

      errorNotification.style.cssText = `
        position: fixed;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        background: #dc3545;
        color: white;
        padding: 12px 24px;
        border-radius: 4px;
        font-size: 14px;
        z-index: 10002;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        opacity: 0;
        transition: opacity 0.3s ease;
        max-width: 90%;
        text-align: center;
      `;

      document.body.appendChild(errorNotification);
    }

    errorNotification.textContent = message;
    errorNotification.style.opacity = '1';

    clearTimeout(this.errorNotificationTimeout);
    this.errorNotificationTimeout = setTimeout(() => {
      errorNotification.style.opacity = '0';
    }, 4000);
  }

  async addToCart() {
    // Prevent multiple simultaneous add to cart requests
    if (this.isAddingToCart) {
      return;
    }

    this.isAddingToCart = true;

    // Get current selections and quantities
    const paintQuantity = parseInt(this.modal.querySelector('[data-product="paint"] .calculator-modal__quantity-value').textContent) || 0;
    const primerQuantity = parseInt(this.modal.querySelector('[data-product="primer"] .calculator-modal__quantity-value').textContent) || 0;

    const paintVariant = this.getCurrentVariant('paint');
    const primerVariant = this.getCurrentVariant('primer');
    const kitVariant = this.getCurrentVariant('kit');

    // Calculate kit quantities
    const { kitQuantity, remainingPaint, remainingPrimer } = this.calculateKitQuantities(paintQuantity, primerQuantity);

    // Build items array for cart
    const items = [];

    // Add kits if needed
    if (kitQuantity > 0 && kitVariant && kitVariant.id) {
      items.push({
        id: parseInt(kitVariant.id),
        quantity: kitQuantity
      });
    }

    // Add remaining paint if needed
    if (remainingPaint > 0 && paintVariant && paintVariant.id) {
      items.push({
        id: parseInt(paintVariant.id),
        quantity: remainingPaint
      });
    }

    // Add remaining primer if needed
    if (remainingPrimer > 0 && primerVariant && primerVariant.id) {
      items.push({
        id: parseInt(primerVariant.id),
        quantity: remainingPrimer
      });
    }

    // Check if we have items to add
    if (items.length === 0) {
      console.warn('No items to add to cart');
      this.showError('Please select at least one product to add to cart.');
      this.isAddingToCart = false;
      return;
    }

    // Get the cart drawer element
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      console.error('Cart drawer element not found');
      this.showError('Unable to add to cart. Please refresh the page.');
      this.isAddingToCart = false;
      return;
    }

    // Show loading state on add to cart button
    const addToCartBtn = this.modal.querySelector('.calculator-modal__add-to-cart');
    const originalBtnHTML = addToCartBtn?.innerHTML || '';

    if (addToCartBtn) {
      addToCartBtn.innerHTML = 'Adding to Cart...';
      addToCartBtn.disabled = true;
    }

    try {
      // Add items to cart and open drawer
      await cartDrawer.addItemsAndOpen(items);

      // Re-enable button before closing modal
      if (addToCartBtn) {
        addToCartBtn.innerHTML = originalBtnHTML;
        addToCartBtn.disabled = false;
      }

      // Close the calculator modal after successful addition
      this.closeModal();

    } catch (error) {
      console.error('Error adding items to cart:', error);
      this.showError(error.message || 'Failed to add items to cart.');

      // Show error state briefly
      if (addToCartBtn) {
        addToCartBtn.innerHTML = 'Error - Try Again';
        setTimeout(() => {
          addToCartBtn.innerHTML = originalBtnHTML;
          addToCartBtn.disabled = false;
        }, 2000);
      }
    } finally {
      // Always reset the flag
      this.isAddingToCart = false;
    }
  }
}

// Initialize the calculator modal when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  window.calculatorModal = new CalculatorModal();
});

// Export for use in other scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = CalculatorModal;
}
